<button mat-fab class="toggle-messages" color="primary" (click)="openPanel()"
    [matBadge]="newMessagesCount && newMessagesCount.newMessages > 0 ? newMessagesCount.newMessages : null"
    matBadgePosition="above after" matBadgeColor="accent">
    <mat-icon aria-label="Visa meddelanden">message</mat-icon>
</button>
